import { render, staticRenderFns } from "./ContentCourseImage.vue?vue&type=template&id=e6f2d5f2&scoped=true"
import script from "./ContentCourseImage.vue?vue&type=script&lang=js"
export * from "./ContentCourseImage.vue?vue&type=script&lang=js"
import style0 from "./ContentCourseImage.vue?vue&type=style&index=0&id=e6f2d5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f2d5f2",
  null
  
)

export default component.exports